<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="dialogForm"
          :rules="formRule"
          label-position="right"
          label-width="140px"
          :model="dialogForm"
          @submit.native.prevent
        >
          <el-form-item label="卡牌名称" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="请输入卡牌名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="卡牌正面点亮图:" prop="fileProp">
            <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
            <UploadFile
              :limit="1"
              :fileList="fileList"
              :fileMaxSize="2"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp"
              :httpRequest="uploadFileHttp"
              :handleRemove="handleRemove"
            >
            </UploadFile>
          </el-form-item>
          <el-form-item label="卡牌反面点亮图:" prop="fileProp2">
            <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
            <UploadFile
              :limit="1"
              :fileList="fileList2"
              :fileMaxSize="2"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp2"
              :httpRequest="uploadFileHttp2"
              :handleRemove="handleRemove2"
            />
          </el-form-item>
          <el-form-item label="卡牌正面未点亮图:" prop="fileProp3">
            <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
            <UploadFile
              :limit="1"
              :fileList="fileList3"
              :fileMaxSize="2"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp3"
              :httpRequest="uploadFileHttp3"
              :handleRemove="handleRemove3"
            />
          </el-form-item>
          <el-form-item label="卡牌反面未点亮图:" prop="fileProp4">
            <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
            <UploadFile
              :limit="1"
              :fileList="fileList4"
              :fileMaxSize="2"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp4"
              :httpRequest="uploadFileHttp4"
              :handleRemove="handleRemove4"
            />
          </el-form-item>
          <el-form-item label="卡牌等级" prop="level">
            <el-select
              v-model="dialogForm.level"
              clearable
              filterable
              placeholder="请选择卡牌等级"
            >
              <el-option
                v-for="(item, index) in levels"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-switch
              v-model="dialogForm.status"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="绑定电台" prop="translate_id">
            <el-select
              v-model="dialogForm.translate_id"
              clearable
              filterable
              placeholder="请选择电台"
            >
              <el-option
                v-for="item in storeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <div class="dialog-footer">
            <el-button @click="resert">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-card>
    <el-dialog
      title="等级"
      :visible.sync="dialogVisible"
      width="20%"
      center
    >
      <el-input placeholder="请输入等级" v-model="dialogForm.level" style="width: 100%" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确定</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import { getCardList, createCardApi, updateCard, delCard, uploadFiles, getTranslateList } from "@/api/radio"
import { getImgName } from "@/utils/cutImgName"
import UploadFile from "../../../components/uploadFile.vue";
export default {
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisibleT: false,
      dialogImageUrl: '',
      getImgName,
      storeList: [],
      dialogVisible: false, // 模态框是否展示
      dialogForm: {
        name: '',
        station: '',
        fileProp: '',
        fileProp2: '',
        fileProp3: '',
        fileProp4: '',
        level: '',
        translate_id:  null,
        status: true,
      }, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      tableData: [],
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      type: '',
      id: null,
      levels: [],
      series_id: null,
      formRule: {
        name: {
          required: true,
          message: "请输入卡牌名称",
          trigger: "blur",
        },
        level: {
          required: true,
          message: "请选择卡牌等级",
          trigger: "blur",
        },
        translate_id: {
          required: true,
          message: "请选择电台",
          trigger: "blur",
        },
        fileProp: { required: true, message: '请上传至少一个文件', trigger: 'change'},
        fileProp2: { required: true, message: '请上传至少一个文件', trigger: 'change'},
        fileProp3: { required: true, message: '请上传至少一个文件', trigger: 'change'},
        fileProp4: { required: true, message: '请上传至少一个文件', trigger: 'change'},
      },
    }
  },
  created() {
    this.getTransList()
    this.type  = this.$route.query.type
    this.levels = JSON.parse(sessionStorage.getItem('levels'))
    // this.levels = JSON.parse(this.$route.query.levels)
    this.series_id = Number(this.$route.query.series_id)
    if(this.type == 'edit'){
      let param = JSON.parse(sessionStorage.getItem('card'))
      console.log(333, param)
      // let param = JSON.parse(this.$route.query.row)
      this.id = param.id
      this.dialogForm.fileProp = param.front_up
      this.dialogForm.fileProp2 = param.backend_up
      this.dialogForm.fileProp3 = param.front_down
      this.dialogForm.fileProp4 = param.backend_down
      this.dialogForm.level = param.level
      this.dialogForm.status = param.status == 1 ? true : false
      this.dialogForm.translate_id = param.translate_id
      this.dialogForm.name = param.name
      this.fileList = [
        {
          name: this.getImgName(param.front_up),
          url: param.front_up,
        },
      ]
      this.fileList2 = [
        {
          name: this.getImgName(param.backend_up),
          url: param.backend_up,
        },
      ]
      this.fileList3 = [
        {
          name: this.getImgName(param.front_down),
          url: param.front_down,
        },
      ]
      this.fileList4 = [
        {
          name: this.getImgName(param.backend_down),
          url: param.backend_down,
        },
      ]
    }
  },
  mounted() {},

  methods: {
    async getTransList(){
      let params = {
        page: 1,
        page_size: 10000000000,
        name: '',
        start: '',
        end: ''
      };
      await getTranslateList(params)
        .then((res) => {
          if (res && res.code) {
            this.storeList = res.data.data_list
          }
        })
        .catch((e) => {
        });
    },
    uploadFileHttp(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove()
      })
    },
    uploadFileHttp2(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp2 = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove2()
      })
    },
    uploadFileHttp3(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp3 = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove3()
      })
    },
    uploadFileHttp4(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp4 = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove4()
      })
    },
    
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.dialogForm.fileProp = ''
    },
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
      this.dialogForm.fileProp2 = ''
    },
    handleRemove3(file, fileList) {
      this.fileList3 = fileList
      this.dialogForm.fileProp3 = ''
    },
    handleRemove4(file, fileList) {
      this.fileList4 = fileList
      this.dialogForm.fileProp4 = ''
    },

    submitForm(){
      if(this.type == 'add'){
        let param = {
          name: this.dialogForm.name,
          status: this.dialogForm.status ? 1 : 0,
          level: this.dialogForm.level,
          front_up: this.dialogForm.fileProp,
          backend_up: this.dialogForm.fileProp2,
          front_down: this.dialogForm.fileProp3,
          backend_down: this.dialogForm.fileProp4,
          series_id: this.series_id,
          translate_id: this.dialogForm.translate_id
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createCardApi(param).then(res => {
                console.log(res)
                if(res.data){
                  this.$router.go(-1)
                }
              })
              .catch(error => { 
                this.$message({
                  type: 'warning',
                  message: error.msg
                });
              })
            })
          }
        })
      } else {
        let param = {
          name: this.dialogForm.name,
          status: this.dialogForm.status ? 1 : 0,
          level: this.dialogForm.level,
          front_up: this.dialogForm.fileProp,
          backend_up: this.dialogForm.fileProp2,
          front_down: this.dialogForm.fileProp3,
          backend_down: this.dialogForm.fileProp4,
          series_id: this.series_id,
          translate_id: this.dialogForm.translate_id,
          id: this.id
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateCard(param).then(res => {
                console.log(res)
                if(res.data){
                  this.$router.go(-1)
                }
              })
              .catch(error => { 
                this.$message({
                  type: 'warning',
                  message: error.msg
                });
              })
            })
          }
        })
      }
    },
    resert(){
      this.$router.go(-1)
    },
    add(){

    },
  },
};
</script>
<style lang="scss" scoped>
.file-tip{
  color: red;
  font-weight: 600;
}
</style>
